"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemCommand = exports.systemCommands = exports.RadioSurvey = exports.UpdateOta = exports.FactoryReset = exports.Reboot = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../json"));
const semver_1 = require("../../../semver");
const NAMESPACE = 'Culligan.Device.Capability.Command';
class Reboot extends effect_1.Schema.Class(`${NAMESPACE}.Reboot`)({
    command: effect_1.Schema.tag('reboot'),
}, {
    identifier: `${NAMESPACE}.Reboot`,
    title: 'Reboot',
    description: 'Instruct the device to reboot',
}) {
}
exports.Reboot = Reboot;
class FactoryReset extends effect_1.Schema.Class(`${NAMESPACE}.FactoryReset`)({
    command: effect_1.Schema.tag('factory.reset'),
}, {
    identifier: `${NAMESPACE}.FactoryReset`,
    title: 'Factory Reset',
    description: 'Instruct the device to reset to factory defaults',
}) {
}
exports.FactoryReset = FactoryReset;
class UpdateOta extends effect_1.Schema.Class(`${NAMESPACE}.UpdateOta`)({
    command: effect_1.Schema.tag('ota.update'),
    params: effect_1.Schema.Struct({
        url: effect_1.Schema.NonEmptyTrimmedString,
        buildFile: effect_1.Schema.NonEmptyTrimmedString,
        targetVersion: semver_1.SemVer,
        options: Json.Value,
    }),
}, {
    identifier: `${NAMESPACE}.UpdateOta`,
    title: 'Update OTA',
    description: 'Instruct the device to update to a new version of its firmware via OTA',
}) {
}
exports.UpdateOta = UpdateOta;
class RadioSurvey extends effect_1.Schema.Class(`${NAMESPACE}.RadioSurvey`)({
    command: effect_1.Schema.tag('radio.survey'),
}, {
    identifier: `${NAMESPACE}.RadioSurvey`,
    title: 'Radio Survey',
    description: 'Instruct the device to perform a radio survey',
}) {
}
exports.RadioSurvey = RadioSurvey;
exports.systemCommands = [
    Reboot,
    FactoryReset,
    UpdateOta,
    RadioSurvey,
];
exports.SystemCommand = effect_1.Schema.Union(...exports.systemCommands).annotations({
    identifier: `${NAMESPACE}.SystemCommand`,
    title: 'System Command',
});
//# sourceMappingURL=command.js.map